import http from './http';
import { handleResponse } from '@/shared/utils/promise-helpers';

const fieldParamByChannel = (channel) => {
  const fieldName = {
    voice: 'id',
    whatsapp: 'whatsapp_identifier',
    chat: 'chat_identifier',
  };

  return fieldName[channel];
};

const contactService = {
  search(parameters) {
    return http.get('/contacts', { params: parameters });
  },

  getContactsByTemplate(
    filterId,
    page,
    per_page,
    search,
    agent,
    preferential,
    org_unit,
    contact_tags,
    employer_tags,
  ) {
    const params = { per_page, page, search, agent, preferential, org_unit };

    if (contact_tags) {
      params.contact_tags = contact_tags;
    }

    if (employer_tags) {
      params.employer_tags = employer_tags;
    }

    return http.get(`/template/contact-filters/contacts/${filterId}`, {
      params,
    });
  },

  getById(id) {
    return http.get(`/contacts/${id}`).then((res) => res.data);
  },

  getByEmployer(
    agentId,
    employerId,
    preferential,
    paginationParams = { per_page: 9999 },
  ) {
    const params = {
      preferential,
      agent: agentId,
      employerId,
      ...paginationParams,
    };

    return http.get('/contacts', { params }).then((res) => res.data);
  },

  getByIdentifier(
    identifier,
    field = 'whatsapp_identifier',
    agent = null,
    emptyOrgUnit = true,
  ) {
    return http
      .get(`/contacts/${identifier}`, {
        params: { by_field: field, agent, empty_org_unit: emptyOrgUnit },
      })
      .then((res) => res.data);
  },

  getContactWithCategories(id, agent = null) {
    return http.get(`/contacts/${id}/columns`, {
      params: { group_by: 'category', agent },
    });
  },

  getContactColumns(identifier = null, channel = 'whatsapp') {
    const params = {
      by_field: fieldParamByChannel(channel),
    };

    if (identifier)
      return http.get(`/contacts/${identifier}/columns`, { params });

    return http.get('/contacts/columns');
  },

  getContactColumnsByCategory(
    identifier = null,
    agent = null,
    orgUnitId = null,
  ) {
    let params = {
      group_by: 'category',
      agent,
      orgUnitId,
    };
    if (identifier) {
      return http.get(`/contacts/${identifier}/columns`, { params });
    }
    return http.get('/contacts/columns', { params });
  },

  getContactHistory(parameters) {
    return http.get('/contacts/history', { params: parameters });
  },

  save(contact, agent = null) {
    if (contact.id) {
      return http.put(`/contacts/${contact.id}`, { contact, agent });
    }
    return http.post('/contacts', { contact, agent });
  },
};
export default contactService;

export const getContactByPhone = (phone, agent = null) =>
  http
    .get(`/contacts/${phone}?channel=voice&by_field=phone1&agent=${agent}`)
    .then((res) => res.data);

export const getContactColumns = (
  identifier = null,
  field = 'whatsapp_identifier',
) => {
  let params = {
    by_field: field,
  };
  if (identifier) {
    return http.get(`/contacts/${identifier}/columns`, { params });
  }
  return http.get('/contacts/columns');
};

export const getDateLastContact = (contactIdentifier) =>
  http
    .get(`/contacts/${contactIdentifier}/last-contact`)
    .then((res) => res.data);

export const getContactBySchedule = (scheduleId, isTelemessage = false) => {
  const params = {
    is_telemessage: isTelemessage,
  };
  return http
    .get(`/schedules/${scheduleId}/contact`, { params })
    .then(handleResponse);
};

export const getMessageHistory = (
  contactIdentifier,
  initialDate,
  page,
  channel,
  mustNot,
  org_unit_id,
  protocol_transfer,
  attendanceType,
  route,
) => {
  const params = {
    initial_date: initialDate,
    page,
    channel,
    must_not: mustNot,
    org_unit_id,
    protocol_transfer,
    attendanceType,
    route,
  };

  console.log('Par�metros para recuperar o hist�rico de mensagens', params);

  return http
    .get(`/contacts/${contactIdentifier}/messages`, { params })
    .then(handleResponse);
};

export const getMessageHistoryDb = (contactIdentifier, protocol) => {
  const params = { protocol };
  return http
    .get(`/contacts/${contactIdentifier}/messages/db`, { params })
    .then(handleResponse);
};

export const vinculateDataWithContactByChannel = ({
  contactId,
  channel,
  data,
}) => {
  const params = {
    data,
  };
  return http.put(
    `/contacts/${contactId}/vinculate-with-contact/${channel}`,
    params,
  );
};

export const deleteContact = (identifier, agentId) =>
  http.delete(`/contacts/${identifier}/${agentId}`);

/**
 * getContactLatestInteraction
 * Busca o contato por contactIdentifier que teve a última interação com o agente
 * @requestType GET
 * @param string agentId
 * @param string contactIdentifier
 * @param string orgUnitId
 * @param string channel
 * @param string whatsAppRoute
 * @returns json
 */
export const getContactLatestInteraction = (
  agentId,
  contactIdentifier,
  orgUnitId,
  channel,
  whatsAppRoute,
) =>
  http
    .get('/contacts/latest-contact-interaction', {
      params: { agentId, contactIdentifier, orgUnitId, channel, whatsAppRoute },
    })
    .then(handleResponse);

/**
 * getContactsFilteredByTempalte
 * Listagem de todos os templates de contatos da unidade organizacional
 */
export const getContactFiltersTemplate = (orgUnitId) =>
  http.get(`/template/contact-filters/${orgUnitId}`).then(handleResponse);
